import moment from 'moment';
import styles from './styles.module.scss';
import { hexToRgba } from 'utils';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

type PromotionPropsType = {
  promos: any[];
};

const Promotion = (props: PromotionPropsType) => {
  const { promos } = props;
  const [expandedId, setExpandedId] = useState<number>(0);

  useEffect(() => {
    if (promos.length) setExpandedId(promos[0].Id);
  }, [promos]);

  if (!promos.length) return null;

  const getFormattedDate = (date: string) => {
    if (!date) return undefined;

    try {
      const splittedDate = date.split('T')[0].split('-');
      return `${splittedDate[1]}/${splittedDate[2]}/${splittedDate[0]}`;
    } catch (e) {
      return undefined;
    }
  };

  return (
    <div className={styles.promotions}>
      {promos.map((promo) => {
        return promo.Id === expandedId ? (
          <div
            className={classNames(styles.promotionExpanded, styles.promotion)}
            style={{ background: hexToRgba(promo.BannerColor, 0.25) }}
          >
            <div className={styles.heading}>{promo.Headline}</div>
            {promo.Description && <div className={styles.text}>{promo.Description}</div>}
            {getFormattedDate(promo.ExpirationDate) && (
              <div className={styles.expiry}>{`Expires on ${getFormattedDate(
                promo.ExpirationDate,
              )}`}</div>
            )}
          </div>
        ) : (
          <div
            className={classNames(styles.promotionCollapsed, styles.promotion)}
            style={{ background: hexToRgba(promo.BannerColor, 0.25) }}
            onClick={() => setExpandedId(promo.Id)}
          >
            <div className={styles.heading}>{promo.Headline}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Promotion;
